var React = require('react');

function Right (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / arrow / right"),React.createElement("g",{"key":1},React.createElement("polygon",{"transform":"translate(11.957000, 11.997500) scale(-1, 1) rotate(90.000000) translate(-11.957000, -11.997500) ","points":"10.9565 0.0405 10.9565 20.1265 6.6635 15.8335 5.2495 17.2475 11.9565 23.9545 18.6645 17.2475 17.2495 15.8335 12.9565 20.1265 12.9565 0.0405"}))]);
}

Right.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Right;

Right.default = Right;
